﻿<rdo-chart-export-buttons [config]="chartConfig"></rdo-chart-export-buttons>
<div [rdo-highcharts]="chartConfig" [useVendorExport]="false"></div>